import { connect } from 'react-redux';
import Global from '../../store/global-selectors';

import { PagingContextProvider } from './index';

const mapStateToProps = (state, { pageSelector = Global.selectOrdersGridPage, pageSizeSelector = Global.selectOrdersGridPageSize }) => {
  const page = pageSelector(state);
  const pageSize = pageSizeSelector(state);

  return {
    page,
    pageSize,
  };
};

export const PagingContextProviderContainer = connect(mapStateToProps)(PagingContextProvider);
